import type { AnyAction, ThunkAction } from '@reduxjs/toolkit';

import { adaptPageURLToStore } from 'src/adapters/pageURLToStore/adaptPageURLToStore';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions } from '../slice';

export const syncFromURL = (
  asPath: string,
): ThunkAction<void, ReduxApplicationState, undefined, AnyAction> => {
  return (dispatch, getState) => {
    const state = getState();
    const payload = adaptPageURLToStore(asPath, state);

    dispatch(actions.syncFromURLPayload({ ...payload, asPath }));
  };
};
